
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ProgressComponent from "../../../components/general/ProgressComponent";
import Layout from "../../../components/layouts/Layout";
import editBlock from "../../../assets/images/icons/editBlock.svg";
import eventDel from "../../../assets/images/icons/eventDel.svg";
// import AddPbsPlans from "./AddPbsPlans";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ReactHtmlParser from 'html-react-parser';
import { ToastContainer, toast } from "react-toastify";
import password_eye_icon_circle from "../../../assets/images/icons/password_eye_icon_circle.svg";
import ProtectedComponent from '../../../permissions/ProtectedComponent';
import { permissions } from '../../../permissions/roles';
import useColumnsWithPermission from "../../../permissions/useColumnsWithPermission";
import "react-toastify/dist/ReactToastify.css";
import {
    BASE_URL,
    GET_MEDICAITON_OVERVIEW_LIST_SERVICEUSER,
    DELETE_MEDICINE_STOCK_URL,
} from "../../../env";
import {
    getRecords,
    isSuccess,
    toastSuccessMessages,
    toastErrorMessages,
    deleteRecords,
    catchAsync,
} from "../../../helper/helper";
// import EditPbsPlans from "./EditPbsPlans";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import PermissionWrapper from "../../../permission_advance/PermissionWrapper";
import { hasAnyPermissions } from "../../../permission_advance/PermissionColumn";
function MedicaitonOverviewList() {
    if (localStorage.getItem('medicineListDetail')) {
        localStorage.removeItem('medicineListDetail');
    }
    const storedUserDetails = localStorage.getItem("profileUserDetails");
    const userDetails = JSON.parse(storedUserDetails);
    const [userData, setUserData] = useState([]);



    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [filterSearch, setFilterSearch] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [medicationId, setMedicationIdData] = useState({
        medicationId: null,
    });
    const [isPbsPlans, setIsPbsPlans] = useState(false);
    const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);

    const [showDeletePbsPlans, setShowDeletePbsPlans] = useState(false);
    const subModalDeletePbsPlans = (delMedicineId) => {
        setMedicationIdData({ medicationId: delMedicineId });
        setShowDeletePbsPlans(!showDeletePbsPlans);
        fetchAllRecords();
    };

    // Getting records from DB
    const processFetchRecords = (method, data) => {
        if (method === "get" && data?.status === isSuccess) {
            const actionRecentIncidentsData = data?.data
            const medicineListsData = actionRecentIncidentsData?.map((item) => item);
            // console.log("🚀 ~ processFetchRecords ~ medicineListsData:", medicineListsData)
            setUserData(medicineListsData);
            setFilterSearch(medicineListsData);
            setIsLoading(false);
        } else if (method === "delete" && data?.status === isSuccess) {
            toastSuccessMessages(toast.success, data?.message, "", 500, 500);
            setTimeout(() => {
                setIsPbsPlans(false);
            }, 2000);
        }
    };

    const fetchAllRecords = catchAsync(async (req, res) => {
        const query = {
            serviceUserId: userDetails?.modelId?._id
        }
        const response = await getRecords(GET_MEDICAITON_OVERVIEW_LIST_SERVICEUSER, query);
        processFetchRecords("get", response);
    });

    useEffect(() => {
        fetchAllRecords();
    }, []);

    useEffect(() => {

        if (!isLoading) {
            const apiQuery = {
                skip: 0,
                limit: 10000,
                sortProperty: "medicationName",
                sortOrder: 1
            };
            fetchAllRecords(apiQuery)
        }
    }, [isLoading]);
    // Table Columns

    const getFilteredProperty = (row, property) => {
        return row?.medicationDetails
            ?.filter((item) => item.user === undefined)
            .map((item) => item[property])
            .join(", ");
    };


    const columns = [
        {
            name: "Service User",
            selector: (row) => {
                return (
                    <span className="usersNameInfo">
                        <span className="userInfo">
                            <span className="nameBlock">{`${row?.suFirstMiddleName}`}{" "}{`${row?.suLastName}`}</span>
                        </span>
                    </span>
                );
            },
            width: "20%",
        },
        {
            name: "Medication Detail",
            selector: (row) => {
                return (
                    <>
                        <span>
                            {row?.medicationName}<br />
                            {/* <small>Type:{row?.medicationType}</small><br /> */}
                            <small>No of Doses: {row?.noOfDoses}</small>
                        </span>
                    </>
                );
            },
            wrap: true,
        },
        {
            name: "Status",
            selector: (row) => {
                return (
                    <>
                        <span>
                            {row?.status}
                        </span>
                    </>
                );
            },
            width: "15%",
            center: true
        },
        {
            name: (
                <>
                    <div className="text-center">
                        Safety Time
                        <br />
                        (Mins)
                    </div>
                </>
            ),
            selector: (row) => {
                return (
                    <>
                        <span>
                            {row?.medicationSafetyTime}
                        </span>
                    </>
                );
            },
            width: "15%",
            center: true
        },
        {
            name: "Schedule",
            selector: (row) => {
                return (
                    <>
                        <span className="pt-3 pb-3">
                            <br />
                            Date: {moment(row?.date).format("DD/MM/YYYY")}
                            <br />
                            Dose Time: {row?.doseTime}
                            <br />
                            Start Time: {row?.startTime}
                            <br />&nbsp;
                        </span>
                    </>
                );
            },
            width: "15%",
        },
        ...(hasAnyPermissions(["create", "update", "delete"], "Emar")
            ? [
                {
                    name: "Action",
                    selector: (row) => {
                        return (
                            <div className="actionColumns individualReviewsActions">
                                <PermissionWrapper title="Medicine List" action="update">
                                    <span className="edit" onClick={() => handleEditViewPBSPlans(row, "/edit-medication-overview")}>
                                        <img src={editBlock} alt="Edit" title="Edit" />
                                    </span>
                                </PermissionWrapper>
                            </div>
                        );
                    },
                    width: "10%",
                    center: true,
                    wrap: true,
                },
            ]
            : []),

    ];


    // Search Filter
    useEffect(() => {
        const result = userData.filter((user) => {
            const filterMedicationName = user?.medicationName
            return filterMedicationName.toLowerCase().match(search.toLowerCase());
        });
        setFilterSearch(result);
    }, [search, userData]);

    // Delete PbsPlans records
    const deleteRecord = catchAsync(async (req, res) => {
        setIsSubmitButtonClicked(true);
        if (medicationId !== "") {
            const response = await deleteRecords(
                DELETE_MEDICINE_STOCK_URL,
                medicationId
            );

            setIsPbsPlans(true);
            processFetchRecords("delete", response);
            fetchAllRecords();
            setIsSubmitButtonClicked(false);
            setShowDeletePbsPlans(!showDeletePbsPlans);
        } else {
            setShowDeletePbsPlans(!showDeletePbsPlans);
            setIsSubmitButtonClicked(false);
            setIsPbsPlans(true);
            toastErrorMessages(toast.error, "Unable to remove", "", 1000);
        }
    });
    useEffect(() => {
        setTimeout(() => {
            setIsPbsPlans(false);
        }, 2000);
    }, [isPbsPlans])

    const handleEditViewPBSPlans = (item, url) => {
        localStorage.setItem(
            "medicineListDetail",
            JSON.stringify(item)
        );
        navigate(url);
    };

    return (
        <>
            <Layout pageTitleText="Medication Administration">
                <div className="rowClickUnset pbsPlanUpdated">
                    <div className="mainContent">

                        <div className="dataTableWrapper">
                            <DataTable
                                className="maxWidthTable minWidthTable"
                                columns={columns}
                                data={filterSearch}
                                pagination
                                paginationRowsPerPageOptions={[1, 25, 50, 100]}
                                paginationPerPage={10}
                                fixedHeader
                                fixedHeaderScrollHeight="520px"
                                highlightOnHover
                                actions={
                                    <>
                                        <PermissionWrapper title="Medicine List" action="create">
                                            <Link to="/add-medication-overview" className="btn btn-sm btn-primary">
                                                Add New Administration
                                            </Link>
                                        </PermissionWrapper>
                                    </>
                                }
                                responsive={true}
                                subHeader={true}
                                subHeaderComponent={
                                    <div className="searchContainer">
                                        <div className="searchTextBox">
                                            <input
                                                type="text"
                                                placeholder="Search by Medicine Name"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                }
                                subHeaderAlign="left"
                                subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
                                progressPending={isLoading}
                                progressComponent={<ProgressComponent />}
                            />
                        </div>
                    </div>
                </div>
            </Layout>


            {/* Delete PBS Plans */}

            <Modal
                show={showDeletePbsPlans}
                onHide={subModalDeletePbsPlans}
                className="ftcModalPopup confirmationPopup deletionConfirmation"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="editBlockContent text-center">
                        <img src={eventDel} alt={eventDel} />
                        <p>Are you sure you want to delete this item?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isSubmitButtonClicked ? (
                        <Button className="btn-sm" variant="danger" disabled>
                            Loading...
                        </Button>
                    ) : (
                        <Button className="btn-sm" variant="danger" onClick={deleteRecord}>
                            Yes
                        </Button>
                    )}

                    <Button
                        className="btn-sm"
                        variant="outline-secondary"
                        onClick={subModalDeletePbsPlans}
                    >
                        No
                    </Button>
                </Modal.Footer>
            </Modal>

            {isPbsPlans && <ToastContainer />}
        </>
    );
}

export default MedicaitonOverviewList